import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("button3", component(opts));
  editor.BlockManager.add("button3", block(opts));
};